import apiClient from 'api/api-client';
import { AuthUserResponse, MeResponse } from 'types/login';
import { User, UserStatus } from 'types/user';

export const fetchUserInfo = async () => apiClient.get<MeResponse>('/auth/me');

export const convertMeResponseToUser = (response: AuthUserResponse): User => ({
  id: 1,
  status: UserStatus.PENDING,
  healthcareInstitution: null,
  organizerInstitution: null,
  enabledSystemNotifications: true,
  enabledSystemNotificationsEmail: true,
  restrictActionsWhileImpersonating: response.restrictActionsWhileImpersonating ?? true,
  ...response,
});
